<template>
	<div class="activity-list-item" @click="goToActivityDetail(itemInfo.aid)">
		<div class="item-img">
			<img :src="itemInfo.attach"/>
		</div>
		<div class="item-text" :class="{'over-time':itemInfo.status==3}">
			<p class="item-title">{{itemInfo.title}}</p>
			<p class="item-desc">{{itemInfo.title}}</p>
			<div class="item-other">
				<span class="item-status">
					<span v-if="itemInfo.status==1">进行中</span>
					<span v-if="itemInfo.status==2">已删除</span>
					<span v-if="itemInfo.status==3">已结束</span>
				</span>
				<span class="item-join-num">
					<img src="../../assets/img/finds/ic_find_list_people@2x.png" alt="" />
					<span>{{itemInfo.enrolment}}</span>人
				</span>
			</div>
		</div>
		<span class="item-isfee" v-if="itemInfo.registration_fee==0">免费</span>
	</div>
</template>

<script>
	export default{
		name:"activity-list-item",
		props:["itemInfo"],
		data(){
			return{
				
			}
		},
		methods:{
			goToActivityDetail(id){
				this.$router.push({
					name:"activity-detail",
					query:{
						id:id
					}
				})
			}
		}
	}
</script>

<style scoped>
	.activity-list-item{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding: 0 1rem;
		margin: 1rem 0;
		position: relative;
	}
	.activity-list-item .item-img img{
		width: 8.5rem;
		display: block;
		border-radius: 5px;
	}
	.activity-list-item .item-text{
		flex: 1;
		padding: 0 0.5rem;
		padding-right: 0;
	}
	.activity-list-item .item-text.over-time{
		filter: grayscale(100%);
	}
	.activity-list-item .item-title{
		font-weight: bold;
		font-size: 1rem;
		line-height: 1.5rem;
		margin-bottom: 0.5rem;
		color: #282828;
	}
	.activity-list-item .item-desc{
		font-size: 0.8rem;
		color: #7b7b7b;
		overflow: hidden;
		text-overflow: ellipsis;
		display:-webkit-box;
		-webkit-box-orient:vertical;
		-webkit-line-clamp:3;
	}
	.activity-list-item .item-other{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0.5rem 0;
	}
	.activity-list-item .item-status{
		font-size: 0.8rem;
	    color: #fff;
	    background: #ff9090;
	    display: inline-block;
	    padding: 0.3rem 0.5rem;
	    border-radius: 3px;
	}
	.activity-list-item .item-join-num{
		display: flex;
		align-items: center;
		font-size: 0.8rem;
		color: #282828;
	}
	.activity-list-item .item-join-num span{
		color: #ff8e90;
	}
	.activity-list-item .item-other img{
		width: 1.5rem;
	}
	.activity-list-item .item-isfee{
		position: absolute;
		top: 0;
		left: 1rem;
		display: inline-block;
		background: #ff6160;
		font-size: 0.8rem;
		color: #fff;
		padding: 0.2rem 0.5rem;
		border-radius: 5px 0;
	}
</style>


// WEBPACK FOOTER //
// src/components/Finds/ActivityListItem.vue